
import { defineComponent, nextTick, PropType, ref } from "vue";
import { Database } from "firebase/database";
import RRuleInput from "@/components/databases/task_configurations/RRuleInput.vue";
import SeDropdownItem from "../global/dropdown/SeDropdownItem.vue";
import { collection, doc, DocumentReference } from "firebase/firestore";
import * as Lang from "@/i18n/lang";
import * as Snackbars from "@/utils/Snackbars";
import * as ObjectUtils from "@/utils/ObjectUtils";
import { getState as getNavigationState } from "@/pinia/NavigationState";
import SeCheckBox from "../global/SeCheckBox.vue";
import * as Firebase from "@/firebase/Firebase";
import { getBulkDatabaseTaskState } from "@/pinia/tasks/BulkDatabaseTaskState";
import DatabaseTaskConfiguration from "@/model/Tasks/DatabaseTaskConfiguration";
import { getDatabaseTaskConfigurationState } from "@/pinia/tasks/DatabaseTaskConfigurationState";
import { getTaskConfigurationManager } from "@/firebase/TaskConfigurationManager";
import { RRule, rrulestr } from "rrule";
import TaskModuleConfigurationAction from "@/model/Tasks/config/TaskModuleConfigurationAction";
import TaskModuleConfigurationTemperature from "@/model/Tasks/config/TaskModuleConfigurationTemperature";
import TaskModuleConfigurationOils from "@/model/Tasks/config/TaskModuleConfigurationOils";
import TaskActionList from "../databases/TaskActionList.vue";
import SeFadeButton from "../global/SeFadeButton.vue";
import * as DateUtils from "@/utils/DateUtils";
import * as Module from "@/model/Module";
import * as ModuleManager from "@/firebase/ModuleManager";
import { ModuleEnum } from "@/model/ModuleEnum";
import * as TaskTypeManager from "@/firebase/TaskTypeManager";
import TaskType from "@/model/Tasks/TaskType";
import * as Modals from "@/utils/Modals";
import * as SecureatServerApi from "@/utils/SecureatServerApi";

export default defineComponent({
  components: {
    RRuleInput,
    TaskActionList,
  },
  methods: {
    openEditTaskTypeModal(taskTypeRef: DocumentReference) {
      let taskType = this.state.getTaskType(taskTypeRef);
      var refs = <any>this.$refs;

      refs.taskTypeName.setValue(taskType.name);
      refs.colorPicker.setValue(taskType.color);
      refs.taskTypeModal.open(taskType);
    },

    onSearchChange(value: string) {
      this.state.search = value;
    },
    openTaskTypeModal() {
      var refs = <any>this.$refs;
      refs.taskTypeName.setValue("");
      refs.colorPicker.setValue("#454eff");
      refs.taskTypeModal.open();
    },
    async modifyOrCreateTaskType() {
      var refs = <any>this.$refs;

      var name = refs.taskTypeName.getValue();

      var color = refs.colorPicker.getValue();

      if (name.trim() == "") {
        return;
      }

      if (refs.taskTypeModal.context == null) {
        var type = new TaskType(
          doc(
            collection(
              Firebase.firestore,
              this.state.database!.ref.path,
              "task_types"
            )
          ),
          name,
          color,
          false
        );

        await TaskTypeManager.createDatabaseTaskType(
          this.state.getDatabaseId(),
          type
        );

        this.state.taskTypes.push(type);
        this.state.selectedTaskType = type;
      } else {
        var taskType = <TaskType>refs.taskTypeModal.context;

        taskType.name = name;
        taskType.color = color;
        await TaskTypeManager.modifyTaskType(taskType);
      }

      refs.taskTypeModal.close();
    },

    openExportModal() {
      var refs = <any>this.$refs;

      refs.exportModal.open();
    },
    async exportTasks() {
      var refs = <any>this.$refs;

      if (this.state.targetDatabase == null) {
        Snackbars.display("Aucune base de donnée selectionnée.");
        return;
      }

      if (this.state.targetDatabase == this.state.database) {
        Snackbars.display(
          "Impossible d'exporter les tâches vers la base de donnée en cours d'edition."
        );
        return;
      }

      if (this.checkedTasks.length == 0) {
        Snackbars.display("Aucune tâche selectionnée.");
        return;
      }

      refs.exportModal.close();

      let res = await Modals.openYesNo(
        "Vous allez sauvegarder la page et exporter " +
        this.checkedTasks.length +
        " tâches sur " +
        this.state.targetDatabase.name +
        ". Voulez vous continuer ?",
        "Confirmation",
        "Continuer",
        "Annuler"
      );

      if (res) {
        var snackbar = Snackbars.progress("Export en cours...");
        await this.save();
        await this.applyExport();
        Snackbars.remove(snackbar);
      }
      Modals.open("Les tâches ont été exportées.");
    },
    async applyExport() {
      var refs = <any>this.$refs;

      var copyAttachments = refs.exportAttachments.getValue();
      await SecureatServerApi.exportDatabaseTaskConfigurations(
        this.checkedTasks.map((x) => x.ref.id),
        this.state.database.ref.id,
        this.state.targetDatabase.ref.id,
        copyAttachments
      );
    },
    openNewTaskModal() {
      var refs = <any>this.$refs;

      refs.newTaskModal.open();
    },

    createNewTask() {
      let configuration: any = null;

      switch (this.state.selectedModule) {
        case ModuleEnum.Action:
          configuration = new TaskModuleConfigurationAction([]);
          break;

        case ModuleEnum.Temperatures:
          configuration = new TaskModuleConfigurationTemperature(
            [],
            false,
            false
          );
          break;

        case ModuleEnum.Oils:
          configuration = new TaskModuleConfigurationOils([]);
          break;
      }

      var task = new DatabaseTaskConfiguration(
        doc(
          collection(
            Firebase.firestore,
            this.state.database.ref.path,
            "task_configurations"
          )
        ),
        true,
        configuration,
        "",
        [],
        ModuleManager.getModuleFromEnum(this.state.selectedModule).ref,
        Lang.getI18N("new-task"),
        "FREQ=DAILY;INTERVAL=1",
        [],
        false,
        null,
        false,
        true,
        true,
        true,
        true,
        true,
        true,
        true,
        true,
        true
      );

      this.state.tasks.push(task);

      var refs = <any>this.$refs;

      refs.newTaskModal.close();

      this.scrollBottom();
    },
    revertActive() {
      for (let i = 0; i < this.state.tasks.length; i++) {
        let baseTask = this.state.baseTasks[i];

        this.state.tasks[i].active = baseTask.active;
        this.state.tasks[i].active_lock = baseTask.active_lock;
      }
    },
    revertManager() {
      for (let i = 0; i < this.state.tasks.length; i++) {
        let baseTask = this.state.baseTasks[i];

        this.state.tasks[i].requires_manager = baseTask.requires_manager;
        this.state.tasks[i].requires_manager_lock =
          baseTask.requires_manager_lock;
      }
    },
    revertName() {
      for (let i = 0; i < this.state.tasks.length; i++) {
        let baseTask = this.state.baseTasks[i];

        this.state.tasks[i].name = baseTask.name;
        this.state.tasks[i].name_lock = baseTask.name_lock;
      }
    },
    revertRecurrence() {
      for (let i = 0; i < this.state.tasks.length; i++) {
        let baseTask = this.state.baseTasks[i];

        this.state.tasks[i].recurrence = baseTask.recurrence;
        this.state.tasks[i].recurrence_lock = baseTask.recurrence_lock;
      }
    },
    revertType() {
      for (let i = 0; i < this.state.tasks.length; i++) {
        let baseTask = this.state.baseTasks[i];

        this.state.tasks[i].type = baseTask.type;
        this.state.tasks[i].type_lock = baseTask.type_lock;
      }
    },
    revertSchedule() {
      for (let i = 0; i < this.state.tasks.length; i++) {
        let baseTask = this.state.baseTasks[i];

        this.state.tasks[i].starts = [...baseTask.starts];
        this.state.tasks[i].durations = [...baseTask.durations];
        this.state.tasks[i].schedule_lock = baseTask.schedule_lock;
      }
    },
    applyGlobalCheck() {
      var refs = <any>this.$refs;

      let value = !refs.globalCheck.getValue();

      if (value) this.checkedTasks = this.state.tasks.map((x) => x);
      else this.checkedTasks = [];
    },
    onTypeChange(type: DocumentReference) {
      for (let element of this.checkedTasks) {
        element.type = type;
      }
    },
    onTypeLockChange(value: boolean) {
      for (let element of this.checkedTasks) {
        element.type_lock = value;
      }
    },
    onActiveLockChange(value: boolean) {
      for (let element of this.checkedTasks) {
        element.active_lock = value;
      }
    },
    onNameLockChange(value: boolean) {
      for (let element of this.checkedTasks) {
        element.name_lock = value;
      }
    },
    onNameChange(value: string) {
      for (let task of this.checkedTasks) {
        task.name = value;
      }
    },
    onActiveChange(value: boolean) {
      for (let task of this.checkedTasks) {
        task.active = value;
      }
    },
    onManagerChange(value: boolean) {
      for (let task of this.checkedTasks) {
        task.requires_manager = value;
      }
    },
    onManagerLockChange(value: boolean) {
      for (let task of this.checkedTasks) {
        task.requires_manager_lock = value;
      }
    },
    onFilterChange(index: number) {
      this.checkedTasks = [];
      this.state.setFilter(index);
    },
    openTask(task: DatabaseTaskConfiguration) {
      this.state.preventReload = true;
      getDatabaseTaskConfigurationState().set(task, this.state.database);
      getNavigationState().navigate("taskConf");
    },
    duplicate(task: DatabaseTaskConfiguration) {
      let cloned = DatabaseTaskConfiguration.clone(task);

      cloned.name += " (Copy)";

      this.state.tasks.push(cloned);

      this.scrollBottom();
    },
    scrollBottom() {
      var refs = <any>this.$refs;

      nextTick(() => {
        let container = refs.container.parentNode;
        container.scroll(0, container.scrollHeight);

        container = refs.container;
        container.scroll(0, container.scrollHeight);
      });
    },
    async save() {
      var refs = <any>this.$refs;


      let updatedTasks = [] as DatabaseTaskConfiguration[];

      for (let i = 0; i < this.state.tasks.length; i++) {
        if (i >= this.state.baseTasks.length) {
          updatedTasks.push(this.state.elements[i]);
          continue;
        }
        this.state.baseTasks[i].ref = this.state.tasks[i].ref;
        if (
          !ObjectUtils.compareObjects(
            this.state.tasks[i],
            this.state.baseTasks[i]
          )
        ) {
          updatedTasks.push(this.state.tasks[i]);
        }
      }
      for (let t of updatedTasks) {
        await t.set();
      }

      this.state.baseTasks = this.state.tasks.map((x) =>
        DatabaseTaskConfiguration.clone(x)
      );

    },
    onRowClick(task: DatabaseTaskConfiguration) {
      if (this.checkedTasks.includes(task)) {
        let index = this.checkedTasks.indexOf(task);
        this.checkedTasks.splice(index, 1);
      } else {
        this.checkedTasks.push(task);
      }
    },
    openRRuleModal(task: DatabaseTaskConfiguration) {
      let refs = <any>this.$refs;
      refs.rruleModal.open(task);
      let rrule = rrulestr(task.recurrence);
      refs.rruleInput.fromRRule(rrule);
    },
    closeRRuleModal() {
      let refs = <any>this.$refs;
      refs.rruleModal.close();
      let rule = refs.rruleInput.computeRRule();
      let ruleString = rule.toString();

      refs.rruleModal.context.recurrence = ruleString;

      for (let task of this.checkedTasks) {
        task.recurrence = ruleString;
      }
    },
    onRecurrenceLockChange(value: boolean) {
      for (let task of this.checkedTasks) {
        task.recurrence_lock = value;
      }
    },
    recurrenceTitle(task: DatabaseTaskConfiguration): String {
      let rrule = rrulestr(task.recurrence);
      return DateUtils.getFrequenceText(rrule.options.freq);
    },
    revertConfigurations() {
      for (let i = 0; i < this.state.tasks.length; i++) {
        let baseTask = this.state.baseTasks[i];

        this.state.tasks[i].configurations = baseTask.configurations;
        this.state.tasks[i].configurations_lock = baseTask.configurations_lock;
      }
    },
    onConfigurationLockChange(value: boolean) {
      for (let task of this.checkedTasks) {
        task.configuration_lock = value;
      }
    },
    configurationTitle(task: DatabaseTaskConfiguration): String {
      let module = ModuleManager.getModuleFromRef(task.getModule()).toEnum();

      switch (module) {
        case ModuleEnum.Action:
          return (
            (task.configuration as TaskModuleConfigurationAction).actions
              .length + " sous-tâches"
          );
        case ModuleEnum.Temperatures:
          return (
            (task.configuration as TaskModuleConfigurationTemperature)
              .temperature_elements.length + " éléments"
          );
        case ModuleEnum.Oils:
          return (
            (task.configuration as TaskModuleConfigurationOils).oil_elements
              .length + " éléments"
          );
      }
    },
    onScheduleLockChange(value: boolean) {
      for (let task of this.checkedTasks) {
        task.schedule_lock = value;
      }
    },
    openScheduleModal(task: DatabaseTaskConfiguration, index: number) {
      if (index != null) {
        this.scheduleStart = new Date(0, 0, 0, 0, task.starts[index], 0, 0);
        this.scheduleEnd = new Date(
          0,
          0,
          0,
          0,
          task.starts[index] + task.durations[index],
          0,
          0
        );
      }

      let refs = <any>this.$refs;
      refs.scheduleModal.open({
        task: task,
        index: index,
      });
    },
    closeScheduleModal() {
      let refs = <any>this.$refs;
      refs.scheduleModal.close();

      let task = refs.scheduleModal.context.task;
      let index = refs.scheduleModal.context.index;
      let start =
        this.scheduleStart.getHours() * 60 + this.scheduleStart.getMinutes();
      let duration =
        this.scheduleEnd.getHours() * 60 +
        this.scheduleEnd.getMinutes() -
        start;

      if (index != null) {
        task.starts[index] = start;
        task.durations[index] = duration;
      } else {
        for (let t of this.checkedTasks) {
          if (!(t.starts.includes(start) && t.durations.includes(duration)))
            t.starts.push(start);
          t.durations.push(duration);
        }

        if (!this.checkedTasks.includes(task)) {
          task.starts.push(start);
          task.durations.push(duration);
        }
      }
    },
    formatDate(start: number, end: number) {
      let startDate = new Date(0, 0, 0, 0, start, 0, 0);
      let endDate = new Date(0, 0, 0, 0, end, 0, 0);
      return `${startDate.toLocaleTimeString("fr-FR", {
        hour: "2-digit",
        minute: "2-digit",
      })} - ${endDate.toLocaleTimeString("fr-FR", {
        hour: "2-digit",
        minute: "2-digit",
      })}`;
    },
    onScroll() {
      var refs = <any>this.$refs;

      var parent = refs.container;

      if (parent == null) {
        return;
      }

      if (this.oldParentScrollTop - parent.scrollTop < 0) {
        refs.stickContainer.style.top = this.distanceFromTop - 400 + "px";

        refs.tbody.style.top = this.distanceFromTop - 85 + "px";
      } else {
        refs.stickContainer.style.top = this.distanceFromTop - 83 + "px";
        refs.tbody.style.top = this.distanceFromTop + 47 + "px";
      }

      this.oldParentScrollTop = parent.scrollTop;
    },
  },
  mounted() {
    var refs = <any>this.$refs;

    var rect = refs.container.getBoundingClientRect();
    this.distanceFromTop = rect.top - window.scrollY;

    refs.container.addEventListener("scroll", this.onScroll);
    refs.chips.setSelectedIndex(this.state.filter);
    this.onFilterChange(this.state.filter);
  },
  data() {
    return {
      Database: Database,
      Module: Module,
      ModuleEnum: ModuleEnum,
      oldParentScrollTop: 0,
      distanceFromTop: 0,
      Lang: Lang,
      state: getBulkDatabaseTaskState(),
      checkedTasks: [] as DatabaseTaskConfiguration[],
      scheduleStart: new Date(0, 0, 0, 0, 0, 0, 0),
      scheduleEnd: new Date(0, 0, 0, 0, 0, 0, 0),
    };
  },
  setup() { },
});
